import Vue from 'vue'

//export const baseApiUrl = "http://192.168.1.16:3018"
export const baseApiUrl = "https://endpointsambaiba.ml18.com.br"
export const userKey = '__gudma_user'


export function showError(e) {
    if(e && e.response && e.response.data) {
        Vue.toasted.global.defaultError({ msg : e.response.data })
    } else if(typeof e === 'string') {
        Vue.toasted.global.defaultError({ msg : e })

    } else if(typeof e === 'string') {
        Vue.toasted.global.defaultError({ msg : e })   

    } else {
        Vue.toasted.global.defaultError()
    }
}

export default { baseApiUrl, showError, userKey }